"use client";

import { Card, Table } from "react-bootstrap";
import { formatCurrency } from "../../../utils";
import { getPaymentMethodLabel } from "../../../utils/getPaymentMethodLabel";

interface OrderSummaryProps {
  order: any;
}

export const PAYMENT_CHANNEL_CONFIG: Record<
  string,
  { logo?: string; label: string }
> = {
  pse_payment: {
    logo: "/images/payment/logo-pse.jpg",
    label: "PSE",
  },
  card_payment: {
    logo: "/images/payment/tarjeta-logo.jpg",
    label: "Tarjeta",
  },
  bank_transfer: {
    logo: "/images/payment/bancolombia-logo.jpg",
    label: "Transferencia Bancolombia",
  },
  cash_efecty: {
    logo: "/images/payment/efecty-logo.jpg",
    label: "Efecty",
  },
  nequi_payment: {
    logo: "/images/payment/nequi-logo.jpg",
    label: "Nequi",
  },  
};
 
export const PAYMENT_PROVIDER_CONFIG: Record<
  string,
  { logo?: string; label: string }
> = {
  WOMPI: {
    logo: "/images/payment/wompi-logo.png",
    label: "Wompi",
  },
  STRIPE: {
    logo: "/images/payment/stripe-logo.png",
    label: "Stripe",
  },
  MONNET: {
    label: "Monnet",
  },
}

const OrderSummary = ({ order }: OrderSummaryProps) => {
  const channelConfig =
    PAYMENT_CHANNEL_CONFIG[order?.payment_channel];

  const providerConfig =
    PAYMENT_PROVIDER_CONFIG[order?.payment_provider];

  const paymentLogo =
    channelConfig?.logo ?? providerConfig?.logo;

  const paymentLabel =
    channelConfig?.label ??
    providerConfig?.label ??
    getPaymentMethodLabel(order?.payment_method);

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <h3 className="mb-3 mb-lg-4">Resumen de la Orden</h3>

        <div className="default-table-area mb-3 mb-lg-4">
          <div className="table-responsive">
            <Table className="table align-middle">
              <thead>
                <tr>
                  <th scope="col">Descripción</th>
                  <th scope="col" className="text-end">
                    Precio
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="text-secondary fw-medium">
                    Subtotal :
                  </td>
                  <td className="text-secondary fw-medium text-end">
                    {formatCurrency(
                      order?.subtotal,
                      order?.currency ?? "COP"
                    )}{" "}
                    {order?.currency ?? "COP"}
                  </td>
                </tr>

                <tr>
                  <td className="text-secondary fw-medium">
                    Servicio On Line ({order?.comission.percentage??0})% :
                  </td>
                  <td className="text-secondary fw-medium text-end">
                    {(order?.comission.value??0).toLocaleString('es-CO')} {order?.currency ?? "COP"}
                  </td>
                </tr>

                {order?.payment_channel === 'card_payment' && (
                  <tr>
                    <td className="text-secondary fw-medium"> 
                      Costo operación :
                    </td>
                    <td className="text-secondary fw-medium text-end">      
                      500 {order?.currency ?? "COP"}
                    </td>
                  </tr>
                )}

                <tr>
                  <td className="text-secondary fw-medium">
                    Costo de Envío :
                  </td>
                  <td className="text-secondary fw-medium text-end">
                    {order.delivery_type === 'DELIVERY' && order?.shipping_cost === 0 
                      ? 'Asumido por el Cliente'
                      :formatCurrency(
                      order?.shipping_cost,
                      order?.currency ?? "COP"
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="text-secondary fw-medium">
                    Total :
                  </td>
                  <td className="text-secondary fw-medium text-end">
                    {formatCurrency(
                      order?.total,
                      order?.currency ?? "COP"
                    )}{" "}
                    {order?.currency ?? "COP"}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        <div>
          <h6 className="label fs-15 fw-bold text-secondary mb-2">
            Método de Pago
          </h6>

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {paymentLogo && (
                <div className="flex-shrink-0">
                  <img
                    src={paymentLogo}
                    alt={paymentLabel}
                    width={50}
                    height={32}
                  />
                </div>
              )}

              <div className="flex-grow-1 ms-2">
                <span className="d-block fw-medium fs-15 text-secondary">
                  Pago
                </span>
                <span className="fs-13">
                  {paymentLabel}
                </span>
              </div>
            </div>

            <span>
              {formatCurrency(
                order?.total,
                order?.currency ?? "COP"
              )}{" "}
              {order?.currency ?? "COP"}
            </span>
          </div>
        </div>

      </Card.Body>
    </Card>
  );
};

export default OrderSummary;
